export default __webpack_public_path__ + "static/media/Trustpilot.4f6a8a56.webp";